/* eslint-disable indent */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from 'markdown-to-jsx';
import useOnclickOutside from 'react-cool-onclickoutside';
import Loader from '../Loader/Loader';
const GeneralModal = ({ children, classNames, closeModal, description, displayIcon, hasButtons, iconUrl, innerCloseIcon, lightHeading, loading, noButtonText, noButtonUrl, title, yesButtonFunction, yesButtonText }) => {
    const { t } = useTranslation();
    const modalContent = useOnclickOutside(() => {
        closeModal();
    });
    useEffect(() => {
        // eslint-disable-next-line no-undef
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeModal();
            }
        });
    }, []);
    return (React.createElement("div", { tabIndex: -1, className: `overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-full md:h-screen justify-center items-center flex ${children ? 'bg-white' : 'bg-gray-50/75'}`, role: "dialog" },
        !innerCloseIcon && (React.createElement("button", { onClick: closeModal, type: "button", className: "\n          absolute\n          top-4\n          right-4\n          inline-flex\n          items-center\n          justify-center\n          w-12\n          h-12\n          bg-gray-200\n          rounded-full\n        " },
            React.createElement("span", { className: "material-icons text-gray-800" }, "close"))),
        React.createElement("div", { ref: modalContent, className: `
          md:w-full
          w-11/12
          max-w-xl
          h-auto
          m-auto
          absolute
          md:top-16
          top-20
          bg-white
          rounded-lg
          flex
          flex-col
          ${innerCloseIcon ? 'p-6 gap-6' : 'md:p-10 p-8 gap-2.5'}
          ${children ? 'shadow-sm border border-blue-100' : 'shadow-4xl'}
          ${classNames || ''}
        ` },
            React.createElement("div", { className: "w-full flex items-center justify-between gap-3" },
                displayIcon && (React.createElement("img", { src: iconUrl || '/images/small/icons/icon-cir-check.png', alt: t('myPitches.successIcon') })),
                React.createElement("h3", { className: `${innerCloseIcon
                        ? 'text-gray-800 text-2xl font-semibold leading-8'
                        : lightHeading
                            ? 'text-gray-800 text-center text-2xl font-medium mb-0'
                            : 'text-gray-700 text-3xl leading-8 font-semibold text-center'}` }, title),
                innerCloseIcon && (React.createElement("button", { onClick: closeModal, type: "button", className: "inline-flex items-center justify-center w-8 h-8 bg-gray-200 rounded-md" },
                    React.createElement("span", { className: "material-icons text-gray-800" }, "close")))),
            description && (React.createElement(Markdown, { className: "text-gray-700 text-lg modal-markdown" }, description)),
            children && children,
            hasButtons && (React.createElement("div", { className: "flex items-center gap-4 mx-auto mt-6 md:flex-row flex-col" },
                React.createElement("button", { onClick: yesButtonFunction, className: "w-48 text-sm text-white rounded-full bg-blue-400 hover:bg-blue-600 font-normal focus:ring-4 py-3 px-6 inline-flex items-center justify-center" }, loading ? (React.createElement(Loader, { title: t('auth.inbox.loading') })) : (yesButtonText)),
                React.createElement("a", { href: noButtonUrl, className: "w-48 bg-gray-400 border hover:bg-gray-500 font-normal text-sm text-white rounded-full py-3 px-6 inline-flex items-center justify-center" }, noButtonText))))));
};
export default GeneralModal;
